import { SxProps } from '@mui/material';
import { combineSX } from '@/utils/combineSX';
import { DpInformativeFrameSX } from '@/components/blocks/DpLibrary/DpInformativeFrame/styles/frame';
import { DpContainer } from '@/components/blocks/DpContainer';

export const DpInformativeFrame = ({
	children,
	sx,
}: {
	children: React.ReactNode;
	sx?: SxProps;
}) => (
	<DpContainer sx={combineSX([DpInformativeFrameSX, ...(Array.isArray(sx) ? sx : [sx])])}>
		{children}
	</DpContainer>
);
